// @flow
import environment from '../../../environment';
import {
  deleteCreator,
  getCreator,
  postCreator,
  putCreator,
} from '../../../http';

export type SizeChartRequest = {
  sizeChartId?: string,
  id?: string,
};

export type ProductPageSettingRequest = {
  storeSizeChartSetting?: {
    enabled?: boolean,
  },
};

export const endpoints = Object.freeze({
  GET_PRODUCT_PAGE_SETTING: `${environment.baseApiUrl}/im/admin/product/product-page`,
  SAVE_SIZE_CHART: `${environment.baseApiUrl}/im/admin/product/size-chart`,
  GET_SIZE_CHARTS: `${environment.baseApiUrl}/im/admin/product/size-chart`,
  DELETE_SIZE_CHART: `${environment.baseApiUrl}/im/admin/product/size-chart/:sizeChartId`,
  EDIT_SIZE_CHART: `${environment.baseApiUrl}/im/admin/product/size-chart/:sizeChartId`,
});

export const getProductPageSettingApi = getCreator(
  endpoints.GET_PRODUCT_PAGE_SETTING
);
export const saveProductPageSettingApi = postCreator(
  endpoints.GET_PRODUCT_PAGE_SETTING
);
export const getSizeChartsApi = getCreator(endpoints.GET_SIZE_CHARTS);
export const saveSizeChartApi = postCreator(endpoints.SAVE_SIZE_CHART);
export const deleteSizeChartApi = deleteCreator(endpoints.DELETE_SIZE_CHART);
export const editSizeChartApi = putCreator(endpoints.DELETE_SIZE_CHART);
